// Vendors
import React from 'react';
import { useTranslation } from 'react-i18next';
// Context
import { MessagingState } from '@context/Context';
// Types
import { IDiscussionThreadSelectPayload } from '@root/services/payloads/servicePayloads';

interface Props {
    setMessage: (message: IDiscussionThreadSelectPayload) => void;
    setInfoModalOpen: (isOpen: boolean) => void;
}

const RecipientToggles = ({ setMessage, setInfoModalOpen }: Props) => {
    const {
        state: { message },
    } = MessagingState();
    const { t } = useTranslation();

    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = e.target;
        const updatedMessage = { ...message, [name]: checked };

        if (name === 'seeNames' && !checked) {
            updatedMessage.seeResponses = false;
        }
        setMessage(updatedMessage);
    };

    return (
        <>
            <div className="switch">
                <input
                    type="checkbox"
                    id="check-see-other-names"
                    name="seeNames"
                    onChange={handleCheckboxChange}
                    checked={message.seeNames}
                />
                <label
                    htmlFor="check-see-other-names"
                    className="togglemark">
                    {t('inputs.seeOtherNames')}
                </label>
            </div>
            <div className="switch">
                <input
                    type="checkbox"
                    id="check-see-other-responses"
                    name="seeResponses"
                    disabled={!message.seeNames}
                    onChange={handleCheckboxChange}
                    checked={message.seeResponses}
                />
                <label
                    htmlFor="check-see-other-responses"
                    className="togglemark">
                    {t('inputs.seeOtherResponses')}
                </label>
            </div>
            <div
                id="show-other-settings-info"
                tabIndex={0}
                onKeyDown={e => e.key === 'Enter' && setInfoModalOpen(true)}
                onClick={() => setInfoModalOpen(true)}>
                {t('inputs.otherSettingsInfo')}
            </div>
        </>
    );
};

export default RecipientToggles;
